import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[codeSnippet]',
  standalone: false,
})
export class CodeSnippetDirective {
  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.renderCode();
  }

  renderCode(): void {
    if (this.el.nativeElement.tagName != 'TEXTAREA') {
      try {
        this.el.nativeElement.innerHTML =
          '<div style="background-color:#ffaaaa; padding:10px;">codeSnippet can only be applied to TEXTAREA!</div>';
      } catch {
        throw 'codeSnippet can only be applied to TEXTAREA!';
      }
      return;
    }

    let html = this.el.nativeElement.defaultValue.trimEnd();

    let newContent = this.clean(html);

    this.el.nativeElement.defaultValue = newContent;
    this.el.nativeElement.setAttribute('class', 'codeSnippet');
    this.el.nativeElement.setAttribute(
      'style',
      'height:' + this.el.nativeElement.scrollHeight + 'px',
    );
  }

  clean(html: string): string {
    let lines = html.split('\n');
    let newContent: string = '';

    let leadingSpaceCount = -1;

    for (var i = 0; i < lines.length; i++) {
      if (leadingSpaceCount == -1) {
        if (lines[i].trim() != '') {
          let len = lines[i].length;
          lines[i] = lines[i].trimStart();
          leadingSpaceCount = len - lines[i].length;

          newContent = this.cleanLine(lines[i]);
        }
      } else {
        lines[i] = lines[i].substring(leadingSpaceCount);
        newContent += '\n' + this.cleanLine(lines[i]);
      }
    }

    return newContent;
  }

  cleanLine(html: string) {
    return html.replace('&lt;', '<').replace('&gt;', '>');
  }
}
